import { Component, ViewChild, ElementRef, HostListener, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { combineLatest } from 'rxjs';

import { Advert } from '../../models/advert.model';
import { AdvertService } from '../../services/advert.service';
import { AccountService } from '../../services/account.service';
import { SearchFormSharedService } from '../search/searchForm/searchForm.shared.service';
import { Candidate } from '../../models/candidate.model';
import { Applicant } from '../../models/applicant.model';
import { AppConfig } from 'src/app/app.config';
import { HelpersService } from '../../helpers/helpers.service';
import { CorporateConfig } from '../../corporate.config';
import { EmailBlockedComponent } from './modals/email-blocked-modal/email-blocked.component';
import { OptionalFieldService } from 'src/app/services/optional-field-service';
import { FormSettingsAbstractComponent } from '../abstract/form-settings.abstract.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TenantService } from 'src/app/services/tenant.service';
import { Router } from '@angular/router';

@Component({
    selector: 'dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent extends FormSettingsAbstractComponent implements OnInit {

    @ViewChild('openChangeEmailModalBtn', { static: false })
    changeEmailModalBtn: ElementRef;

    AdvertsList: Advert[] = [];
    Candidate: Candidate;
    Applications: Applicant[];

    cvUploadNotAllowed: boolean;
    profileCompletionPercentage: number;
    isSkillsAdded: boolean;
    isJobPreferenceAdded: boolean;
    isCVAdded: boolean;
    isRefereeAdded: boolean;
    progressCircle: number;
    findJobsUrl: string;

    dashBoardOuterStrokeColor: string;
    dashBoardInnerStrokeColor: string;
    matDialog: MatDialogRef<EmailBlockedComponent>;
    validateReferees: boolean;
    private DefaultPercentageCompleteOnBasicProfile = 20;
    private DefaultPercentageCompleteOnSkills = 20;
    private DefaultPercentageCompleteOnJobPreference = 20;
    private DefaultPercentageCompleteOnCV = 20;
    private DefaultPercentageCompleteOnReferees = 20;
    private minNumberOfReferees: number = 2;

    unconfirmedEmail = false;

    appConfig = AppConfig;
    isGraduateTalentTenant: boolean = false;
    tenantName: string = '';
    newsEventsUrl = "";
    isAccountApplicationMode = AppConfig.getAccountMode;
    private readonly accountModeUrl = AppConfig.getAccountModeUrl;

    constructor(
        public advertService: AdvertService,
        private accountService: AccountService,
        public searchFormSharedService: SearchFormSharedService,
        public helpersService: HelpersService,
        private dialog: MatDialog,
        private title: Title,
        private optionalFieldsService: OptionalFieldService,
        private tenantService: TenantService,
        private router : Router
    ) {
        super('CandidateJobs', optionalFieldsService);
        this.title.setTitle(this.helpersService.getPageContent(CorporateConfig.dashboardTitle));
    }

    ngOnInit(): void {
        this.validateReferees = AppConfig.ValidateRefereesOnProfileCompleteness;
        if (!this.validateReferees) {
            this.DefaultPercentageCompleteOnBasicProfile = 25;
            this.DefaultPercentageCompleteOnSkills = 25;
            this.DefaultPercentageCompleteOnJobPreference = 25;
            this.DefaultPercentageCompleteOnCV = 25;
            this.isRefereeAdded = true;
        }

        this.onResize();

        combineLatest([this.accountService.existsUnConfirmedEmail(), this.accountService.getCandidate()])
            .subscribe(res => {
                const unconfirmedEmail = res[0];
                const candidate = res[1];

                if (unconfirmedEmail) {
                    this.changeEmailModalBtn.nativeElement.click();
                    this.unconfirmedEmail = unconfirmedEmail;
                }

                this.setModel(candidate);
            });

        this.advertService.getActiveAdvertList().subscribe(result => this.setAdvertList(result));
        this.accountService.applicationsMade().subscribe(res => this.setApplicationsList(res));
        this.accountService.cvUploadNotAllowed().subscribe(res => this.cvUploadNotAllowed = res);

        this.dashBoardOuterStrokeColor = this.helpersService.getPageContent(CorporateConfig.dashBoardOuterStrokeColor);
        this.dashBoardInnerStrokeColor = this.helpersService.getPageContent(CorporateConfig.dashBoardInnerStrokeColor);

        this.tenantService.getTenantDetails()
        .subscribe(tenant => {
          this.tenantName = tenant.TenantDisplayName;
          this.isGraduateTalentTenant = this.tenantName === 'Graduate Talent';
        });
        this.findJobsUrl = (AppConfig.getAccountMode === false && !this.helpersService.getPageContent(CorporateConfig.ClientJobSearchUrl))?`/search`:
        null;

        this.newsEventsUrl = this.appConfig.getAccountMode ? this.appConfig.getAccountModeUrl+`news-events` : ""; 
    }

    ngOnDestroy() {
        if (this.matDialog !== undefined) {
            this.matDialog.close();
        }
    }

    setAdvertList(result: Advert[]) {
        this.AdvertsList = result;
    }

    getAllJobs() {

        const clientJobSearchUrl =  this.accountModeUrl+"search";
        //TODO: Refactor remove CorporateConfig.ClientJobSearchUrl

        if (!this.isAccountApplicationMode){
        this.searchFormSharedService.getAllJobs();
        }
        else {
            document.location.href= clientJobSearchUrl;
        }
    }

    getJobDetails(jobTitle: string, advertId: string) {

        var jobDetailsUrl: string = `/job/${jobTitle}/${advertId}`;
        this.isAccountApplicationMode ?
            document.location.href = this.accountModeUrl + `job/${jobTitle}/${advertId}` :
            this.router.navigate([jobDetailsUrl]);
        }

    @HostListener('window:resize', ['$event'])
    onResize() {
        if ((window.innerWidth <= 992 &&
            window.innerWidth >= 768) ||
            window.innerWidth <= 768) {
            this.progressCircle = 80;
        } else {
            this.progressCircle = 140;
        }
    }

    private setModel(input: Candidate) {

        this.Candidate = Candidate.Copy(input);
        this.profileCompletionPercentage = this.getProfileCompletionPercentage();

        if (input.EmailBlocked && !this.unconfirmedEmail) {
            this.matDialog = this.dialog.open(EmailBlockedComponent, {
                width: '500px',
                autoFocus: false,
                disableClose: true,
                data: {
                    email: input.Email
                }
            });
        }
    }

    private setApplicationsList(result: Applicant[]) {
        this.Applications = result;
    }

    private getProfileCompletionPercentage(): number {
        let profileCompleteness = this.DefaultPercentageCompleteOnBasicProfile;

        if (this.Candidate.HasCv) {
            this.isCVAdded = true;
            profileCompleteness += this.DefaultPercentageCompleteOnCV;
        }

        if (this.Candidate.Personal?.Skills !== null && this.Candidate.Personal?.Skills !== '') {
            profileCompleteness += this.DefaultPercentageCompleteOnSkills;
            this.isSkillsAdded = true;
        }

        let visibleFields = [] as string[];

        if (this.isVisible('CANDIDATE_CONTRACT_TYPE')) {
            visibleFields.push(this.Candidate.JobPreferences?.Contract);
        }

        if (this.isVisible('CANDIDATE_HOURS')) {
            visibleFields.push(this.Candidate.JobPreferences?.Hours);
        }

        if (this.isVisible('CANDIDATE_AVAILABILITY_TO_START_WORK')) {
            visibleFields.push(this.Candidate.JobPreferences?.AvailabilityToWork);
        }

        if (this.isVisible('CANDIDATE_SECTOR_OF_INTEREST')) {
            visibleFields.push(this.Candidate.JobPreferences?.Sectors);
        }

        if (!visibleFields.includes('')) {
            profileCompleteness += this.DefaultPercentageCompleteOnJobPreference;
            this.isJobPreferenceAdded = true;
        }

        if (this.validateReferees) {
            if (this.Candidate.Referee?.length >= this.minNumberOfReferees) {
                profileCompleteness += this.DefaultPercentageCompleteOnReferees;
                this.isRefereeAdded = true;
            }
        }

        return profileCompleteness;
    }
}

